import cx from "classnames";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { map, sortBy } from "lodash";

import Assignment from "@material-ui/icons/Assignment";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoGrid from "components/EnergyCompany/Grid/InfoGrid.jsx";
import InfoGridItem from "components/EnergyCompany/Grid/InfoGridItem.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { capitalizeString } from "services/utils";

const styles = {
  moreInfoWrapper: {
    display: "flex",
    flexDirection: "column",
    gridColumnStart: 1,
    height: 0,
    opacity: 0,
    overflow: "hidden",
    paddingLeft: "10px",
    transition: "opacity 1s ease-out",
    "& a": {
      cursor: "pointer",
    },
  },
  moreInfoWrapperOpened: {
    height: "auto",
    opacity: 1,
  },
  socioName: {
    cursor: "pointer",
  },
};

class CorporateStructure extends Component {
  state = {
    opened: {},
  };

  expand = index => {
    const { opened } = this.state;
    this.setState({ opened: { ...opened, [index]: !opened[index] } });
  }

  render() {
    const { classes, companyResponsibles, selectEmpresa } = this.props;
    const { opened } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12}>
          <ECCard
            content={
              <InfoGrid>
                {sortBy(companyResponsibles, ["role"]).map((socio, index) => (
                  [
                    <InfoGridItem
                      actions={!!opened[index] ? <ExpandLess onClick={() => this.expand(index)} /> : <ExpandMore onClick={() => this.expand(index)} />}
                      key="1"
                      label={(socio.role || "").split("-")[1]}
                      modifiers={["forceNewRowModifier"]}
                      value={
                        <span className={classes.socioName} onClick={() => this.expand(index)}>
                          {capitalizeString(socio.name)}
                        </span>
                      }
                    />,
                    <div className={cx({ [classes.moreInfoWrapper]: true, [classes.moreInfoWrapperOpened]: !!opened[index] })} id="CorporateStructure__outras-empresas" key="2">
                      {socio.outrasEmpresas ? (
                        [
                          map(socio.outrasEmpresas, (outraEmpresa, index) => (
                            <a key={index} onClick={() => selectEmpresa(outraEmpresa)}>{outraEmpresa.nome}</a>
                          )),
                          <small key="info">1 O nome do sócio consta em outras empresas, necessário confirmação via CPF.</small>,
                        ]
                      ) : (
                        <span>Não foram encontradas outras empresas em que este nome faz parte do quadro societário.</span>
                      )}
                    </div>,
                  ]
                ))}
              </InfoGrid>
            }
            icon={<Assignment />}
            title="Quadro Societário"
          />
        </GridItem>
      </GridContainer>
    );
  }
};

CorporateStructure.propTypes = {
  classes: PropTypes.object.isRequired,
  companyResponsibles: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  })).isRequired,
  selectEmpresa: PropTypes.func.isRequired,
};

export { CorporateStructure as CorporateStructureComponent };
export default withStyles(styles)(CorporateStructure);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/CorporateStructure.jsx